<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태(필수)', value: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 장비정보 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="장비정보"
      :tableData="[
        { id: 'name', title: '장비명', type: 'text' },
        { id: 'manufacturer', title: '제조사 또는 모델명', type: 'text' },
        { id: 'standard', title: '장비 규격(정격하중 또는 인양하중 등)', type: 'text' },
      ]"
      :mobile="['name', 'manufacturer']"
      v-model="form.equipmentList"
      class="mt-28px"
    />

    <!-- 점검 대상 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="장비정보"
      :tableData="[
        { id: 'target', title: '장비명', type: 'text' },
        { id: 'director', title: '담당자', type: 'text' },
        { id: 'phone', title: '연락처', type: 'text' },
        { id: 'note', title: '비고', type: 'text' },
      ]"
      :mobile="['target', 'director']"
      v-model="form.targetInspectionList"
      class="mt-28px"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" :title="$t('작업장 합동점검')" v-model="form.inspectList" class="mt-28px" />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검일: { required },
        재해형태: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          작업장합동점검_사업장명: [],
          작업장합동점검_점검대상: [],
        };

        value.summary["작업장합동점검_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.targetInspectionList) {
          value.summary["작업장합동점검_점검대상"].push({
            [data.target]: 1,
          });
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",

        inputD_1: {},
        inputD_2: "",
        inputD_3: {},
        inputD_4: "",
        inputD_5: {},
        inputD_6: "",
        inputD_7: {},
        inputD_8: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        photoList: [],
        fileList: [],
        equipmentList: [{}],
        targetInspectionList: [{}],
        inspectList: [
          {
            content: "안전관리자 지정 여부",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "보건관리자 지정 여부",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "안전보건교육 실시 여부",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "교육결과 기록보존상태",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "안전관리비 적정계상 여부",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "안전관리비 집행실태(타목적, 용도외 사용 등)",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "항목별 적정비율 집행 여부",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "보호구 적격품(검정) 구입 여부",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "개인보호구 지급 여부",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "개인보호구 착용 여부 (방진마스크, 귀마개, 안전모, 안전대, 안전화 등)",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "유해･위험방지계획서 제출 및 이행 여부 등",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "위험물(인화성 물질 등) 관리 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "화재예방 대책(소화기 비치 비상 연락망 편성 등)",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "위험,주의,경고 등 표지판 설치 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "작업장 내 자재의 정리 정돈 및 안전통로 확보 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
        ],
      },
    };
  },
  methods: {
    getTranslateDisasterValue(value) {
      const prefix = "직접입력_";
      if (typeof value === "string" && value.startsWith(prefix)) {
        return value.substring(prefix.length);
      }
      return value;
    },
    applyDisasterValue(translatedValue) {
      const prefix = "직접입력_";
      const previous = this.form.stdInfo["재해형태"];
      if (typeof previous === "string" && previous.startsWith(prefix)) {
        if (typeof translatedValue === "string" && translatedValue.length > 0) {
          this.$set(this.form.stdInfo, "재해형태", `${prefix}${translatedValue}`);
        }
        return;
      }
      this.$set(this.form.stdInfo, "재해형태", translatedValue);
    },
    translationMap() {
      const prefix = "작업장합동점검.합동점검표";
      const equipmentList = Array.isArray(this.form.equipmentList) ? this.form.equipmentList : [];
      const targetInspectionList = Array.isArray(this.form.targetInspectionList) ? this.form.targetInspectionList : [];
      const inspectList = Array.isArray(this.form.inspectList) ? this.form.inspectList : [];
      const photoList = Array.isArray(this.form.photoList) ? this.form.photoList : [];
      const fileList = Array.isArray(this.form.fileList) ? this.form.fileList : [];

      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,
        [`${prefix}.기본정보.점검일`]: this.form.stdInfo["점검일"],
        [`${prefix}.기본정보.점검장소`]: this.form.stdInfo["점검장소"],
        [`${prefix}.기본정보.재해형태`]: this.getTranslateDisasterValue(this.form.stdInfo["재해형태"]),
        [`${prefix}.기본정보.알림 대상자 선택`]: this.form.stdInfo["알림 대상자 선택"],

        [`${prefix}.장비정보`]: equipmentList.map((item) => {
          const data = item || {};
          return {
            장비명: data.name,
            "제조사 또는 모델명": data.manufacturer,
            "장비 규격(정격하중 또는 인양하중 등)": data.standard,
          };
        }),

        [`${prefix}.점검대상`]: targetInspectionList.map((item) => {
          const data = item || {};
          return {
            장비명: data.target,
            담당자: data.director,
            연락처: data.phone,
            비고: data.note,
          };
        }),

        [`${prefix}.작업장 합동점검`]: inspectList.map((item) => {
          const data = item || {};
          return {
            점검분류: data.title,
            점검항목: data.content,
            "비고(보완계획)": data["비고(보완계획)"],
          };
        }),

        [`${prefix}.사진대지`]: photoList.map((item) => {
          const data = item || {};
          return { 사진설명: data.input };
        }),

        [`${prefix}.파일첨부`]: fileList.map((item) => {
          const data = item || {};
          return {
            파일명: data.fileName || data.name,
            파일경로: data.url || data.path,
          };
        }),
      };

      return translateData;
    },
    translate(translate) {
      const prefix = "작업장합동점검.합동점검표";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      this.$set(this.form.stdInfo, "점검일", translate[`${prefix}.기본정보.점검일`]);
      this.$set(this.form.stdInfo, "점검장소", translate[`${prefix}.기본정보.점검장소`]);
      this.applyDisasterValue(translate[`${prefix}.기본정보.재해형태`]);
      this.$set(this.form.stdInfo, "알림 대상자 선택", translate[`${prefix}.기본정보.알림 대상자 선택`]);

      const equipmentList = translate[`${prefix}.장비정보`];
      if (Array.isArray(equipmentList)) {
        const _equipmentList = JSON.parse(JSON.stringify(this.form.equipmentList && this.form.equipmentList.length ? this.form.equipmentList : [{}]));
        for (let i = 0; i < equipmentList.length; i++) {
          if (!_equipmentList[i]) _equipmentList[i] = {};
          _equipmentList[i].name = equipmentList[i]["장비명"];
          _equipmentList[i].manufacturer = equipmentList[i]["제조사 또는 모델명"];
          _equipmentList[i].standard = equipmentList[i]["장비 규격(정격하중 또는 인양하중 등)"];
        }
        this.$set(this.form, "equipmentList", _equipmentList);
      }

      const targetInspectionList = translate[`${prefix}.점검대상`];
      if (Array.isArray(targetInspectionList)) {
        const _targetInspectionList = JSON.parse(JSON.stringify(this.form.targetInspectionList && this.form.targetInspectionList.length ? this.form.targetInspectionList : [{}]));
        for (let i = 0; i < targetInspectionList.length; i++) {
          if (!_targetInspectionList[i]) _targetInspectionList[i] = {};
          _targetInspectionList[i].target = targetInspectionList[i]["장비명"];
          _targetInspectionList[i].director = targetInspectionList[i]["담당자"];
          _targetInspectionList[i].phone = targetInspectionList[i]["연락처"];
          _targetInspectionList[i].note = targetInspectionList[i]["비고"];
        }
        this.$set(this.form, "targetInspectionList", _targetInspectionList);
      }

      const inspectList = translate[`${prefix}.작업장 합동점검`];
      if (Array.isArray(inspectList)) {
        const _inspectList = JSON.parse(JSON.stringify(this.form.inspectList && this.form.inspectList.length ? this.form.inspectList : []));
        for (let i = 0; i < inspectList.length; i++) {
          if (!_inspectList[i]) {
            _inspectList[i] = { title: "", content: "", isChecked: "", "비고(보완계획)": "" };
          }
          _inspectList[i].title = inspectList[i]["점검분류"];
          _inspectList[i].content = inspectList[i]["점검항목"];
          _inspectList[i]["비고(보완계획)"] = inspectList[i]["비고(보완계획)"];
        }
        this.$set(this.form, "inspectList", _inspectList);
      }

      const photoList = translate[`${prefix}.사진대지`];
      if (Array.isArray(photoList)) {
        const _photoList = JSON.parse(JSON.stringify(this.form.photoList && this.form.photoList.length ? this.form.photoList : []));
        for (let i = 0; i < photoList.length; i++) {
          if (!_photoList[i]) _photoList[i] = {};
          _photoList[i].input = photoList[i]["사진설명"];
        }
        this.$set(this.form, "photoList", _photoList);
      }

      const fileList = translate[`${prefix}.파일첨부`];
      if (Array.isArray(fileList)) {
        const _fileList = fileList.map((item) => ({
          fileName: item["파일명"],
          url: item["파일경로"],
        }));
        this.$set(this.form, "fileList", _fileList);
      }
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["재해형태"].required) return "재해형태를 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
